<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        <ng-container [formGroup]="owner">
          <pr-input-column
            label="Précisez le montant exact"
            [derrors]="derrors"
            [isDefault]="false"
            [suffix]="'€/an'"
          >
            <input
              notdot
              placeholder="Ex. : 85000€/an"
              formControlName="incomeValue"
              type="text"
            />
          </pr-input-column>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
